import {
    ProcessCellForExportParams,
    ValueFormatterParams,
    ValueGetterParams,
} from 'ag-grid-community';
import { t } from 'i18next';
import {
    MANTY_STATUS,
    RETIREMENT_SYSTEM,
    INDICIAIRE,
} from 'routes/HumanResourcesModule/business/definitions';
import {
    humanizedRecurrentValues,
    IndiciaireEnum,
    MantyStatus,
    NON_RENSEIGNE,
    RecurrenceEnum,
    RetirementSystem,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

export const floatingFilter = {
    filter: 'agTextColumnFilter',
    floatingFilterComponent: 'textFloatingFilter',
    floatingFilter: true,
    flex: 1,
    suppressFloatingFilterButton: true,
    menuTabs: [
        'filterMenuTab' as const,
        'generalMenuTab' as const,
        'columnsMenuTab' as const,
    ],
    cellStyle: {
        display: 'flex',
        alignItems: 'center',
    },
};

export function recurrentFormatter(
    params:
        | ValueFormatterParams
        | ValueGetterParams
        | ProcessCellForExportParams,
): string {
    let value: RecurrenceEnum | undefined;

    if ('value' in params && params.value) {
        ({ value } = params);
    } else if ('data' in params && params.data?.recurrence) {
        value = params.data.recurrence;
    }

    if (!value) return '';

    value = value.toLowerCase() as RecurrenceEnum;

    if (Object.keys(humanizedRecurrentValues).includes(value)) {
        return humanizedRecurrentValues[value];
    }

    return value;
}

export type HR_POSITION_MAPPING_VALUE_GETTER_FIELD =
    | typeof INDICIAIRE
    | typeof MANTY_STATUS
    | typeof RETIREMENT_SYSTEM;

export type PositionMappingValue =
    | `${MantyStatus}`
    | `${RetirementSystem}`
    | `${IndiciaireEnum}`;

export const getPositionValue = (
    value: PositionMappingValue | '',
    isPlural: boolean = false,
): string => {
    const keySuffix = isPlural ? '_other' : '_one';
    return value
        ? t(`humanResources.settings.positionMapping.${value}${keySuffix}`)
        : NON_RENSEIGNE;
};

export const getPositionValueFromField = (
    field: HR_POSITION_MAPPING_VALUE_GETTER_FIELD,
    params: ValueGetterParams | ValueFormatterParams,
): string | undefined =>
    params.data?.[field] ? getPositionValue(params.data[field]) : '';

export const hrPositionMappingValueGetter =
    (field: HR_POSITION_MAPPING_VALUE_GETTER_FIELD) =>
    (params: ValueGetterParams | ValueFormatterParams) =>
        getPositionValueFromField(field, params);
